<template>
    <div class="home-container">
       <!-- 新增的顶部栏 -->
       <div class="header-bar">
        <div class="header-title">
          <div class="weather-info">
            <template v-if="weatherLoading">
              <el-icon class="is-loading"><Loading /></el-icon>
              加载天气中...
            </template>
            <template v-else-if="weatherError">
              天气数据加载失败
            </template>
            <template v-else>
              <span class="weather-item">
                <img src="http://lzy.zhizhizuimei.top/d02d3caebad34db299348f1310da570d.jpg" class="weather-icon" />
                无锡: {{ currentWeather.wuxi.temp }}°C {{ currentWeather.wuxi.text }}
              </span>
              | 
              <span class="weather-item">
                <img src="http://lzy.zhizhizuimei.top/4a92946847db4e4a8e665f8f1d9aba3c.jpg" class="weather-icon" />
                南京: {{ currentWeather.nanjing.temp }}°C {{ currentWeather.nanjing.text }}
              </span>
            </template>
          </div>
          <div class="center-title">永远都像初次见你那样，使我心荡漾</div>
          <div class="days-counter">和栀栀在一起已经{{ daysTogether }}天</div>
        </div>
        <div class="header-actions">
          <el-dropdown>
            <span class="el-dropdown-link">
              <el-avatar :size="50" src="http://lzy.zhizhizuimei.top/c543033078cc3862dff5ac9dbaceab4c.JPG" />
              <span class="username">{{ username }}</span>
            </span>
            <template #dropdown>
              <el-dropdown-menu>
                <el-dropdown-item @click="logout">退出登录</el-dropdown-item>
              </el-dropdown-menu>
            </template>
          </el-dropdown>
        </div>
      </div>
      <!-- 顶部导航按钮 -->
      <div class="nav-buttons">
        <el-button 
          type="primary" 
          plain
          @click="navigateTo('/home')"
          class="home-button"
        >
          点击我回到主页哟
        </el-button>
  
      </div>


  <!-- ... 保留其他部分不变 ... -->

  <!-- 主内容区 -->
  <div class="main-content">
    <!-- 照片回忆上传区域 -->
    <div class="photo-memory">
      <div class="photo-upload-section">
  <!-- 原生input元素 -->
  <input
    id="folderInput"
    type="file"
    webkitdirectory
    directory
    multiple
    @change="handleFolderChange"
    style="display: none"
    accept="image/*"
  >
  
  <!-- 自定义样式按钮 -->
  <el-button 
    type="primary" 
    @click="triggerFolderSelect"
    class="upload-btn"
  >
    <el-icon><Upload /></el-icon>
    上传文件夹
  </el-button>
  
  <div class="upload-tip">支持上传整个文件夹，包含JPG/PNG等图片格式</div>
  <div class="upload-progress" v-if="uploadProgress > 0 && uploadProgress < 100">
      <el-progress 
        :percentage="uploadProgress"
        :stroke-width="15"
        :text-inside="true"
        status="success"
      />
      <div class="progress-text">上传中... {{ uploadProgress }}%</div>
    </div>
</div>

      <div class="photo-albums">
        <div class="photo-albums-header">
          <h3>回忆相册</h3>
          <el-input
            v-model="albumSearch"
            placeholder="搜索相册"
            clearable
            style="width: 200px"
            @clear="fetchPhotoAlbums"
            @keyup.enter="fetchPhotoAlbums"
          >
            <template #append>
              <el-button :icon="Search" @click="fetchPhotoAlbums" />
            </template>
          </el-input>
        </div>

        <el-row :gutter="20" class="album-container">
          <el-col 
            v-for="album in photoAlbums" 
            :key="album.id"
            :xs="24" :sm="12" :md="8" :lg="6" :xl="4"
          >
            <div class="album-card" @click="openAlbum(album)">
              <div class="album-cover">
                <el-image 
                  :src="album.cover" 
                  fit="cover"
                  class="photo-thumbnail"
  lazy
  :preview-src-list="currentAlbumPhotos.map(p => p.url)"
  :initial-index="index"
  hide-on-click-modal
  :z-index="9999"
  preview-teleported 
                >
                  <template #error>
                    <div class="album-cover-error">
                      <el-icon><Picture /></el-icon>
                      <span>封面加载失败</span>
                    </div>
                  </template>
                </el-image>
                <div class="album-info">
                  <div class="album-name">{{ album.name }}</div>
                  <div class="album-count">{{ album.count}}张照片</div>
                </div>
              </div>
              <div class="album-date">{{ formatDate(album.createTime) }}</div>
              <div class="album-actions">
                <el-button 
                  type="danger" 
                  size="small" 
                  @click.stop="deleteAlbum(album)"
                  :icon="Delete"
                  circle
                />
              </div>
            </div>
          </el-col>
        </el-row>
        <div class="pagination-container">
  <div class="custom-pagination">
    <el-button 
      class="page-first" 
      :disabled="albumCurrentPage === 1 || total === 0"
      @click="goToPage(1)"
    >
      <el-icon><ArrowLeft /></el-icon> 首页
    </el-button>
    <el-button 
      class="page-prev" 
      :disabled="albumCurrentPage === 1 || total === 0"
      @click="goToPage(albumCurrentPage - 1)"
    >
      <el-icon><ArrowLeft /></el-icon>
    </el-button>
        <!-- 分页 -->
        <div class="page-input">
      <span>第</span>
      <el-input
        v-model="inputPage"
        placeholder="页码"
        style="width: 60px"
        @keyup.enter="handlePageInput"
        :disabled="total === 0"
      />
      <span>页</span>
      <span class="total-pages">共 {{ totalPages }} 页</span>
    </div>
    
    <el-button 
      class="page-next" 
      :disabled="albumCurrentPage === totalPages || total === 0"
      @click="goToPage(albumCurrentPage + 1)"
    >
      <el-icon><ArrowRight /></el-icon>
    </el-button>
    <el-button 
      class="page-last" 
      :disabled="albumCurrentPage === totalPages || total === 0"
      @click="goToPage(totalPages)"
    >
      尾页 <el-icon><ArrowRight /></el-icon>
    </el-button>
      </div>
    </div>
  </div>
</div>
    <!-- 相册预览对话框 -->
    <el-dialog
      v-model="albumPreviewVisible"
      :title="currentAlbum?.name"
      width="90%"
      top="5vh"
       class="preview-dialog"
       @closed="resetPreview"
    >
      <div class="album-preview-container">
        <div class="album-toolbar">
      <el-upload
        :auto-upload="false"
        :show-file-list="false"
        :on-change="handleFileChange"
        :on-success="handleUploadSuccess"
        :before-upload="beforeUpload"
      >
      <el-button type="primary" size="small">
          <el-icon><Upload /></el-icon>添加照片
        </el-button>
      </el-upload>
    </div>
        <el-image-viewer
          v-if="showImageViewer"
          :url-list="currentAlbumPhotos"
          :initial-index="currentPhotoIndex"
          @close="closeImageViewer"
          teleported
        />
        
        <div v-else class="album-photo-grid">
          <div 
        v-for="(photo, index) in currentAlbumPhotos" 
        :key="'photo-'+photo.photoid"
        class="photo-item"
        @click="handlePreview(index)"
      >
          <img
          :src="photo.url"
          class="photo-thumbnail"
          loading="lazy"
        >
        <el-image-viewer
    v-if="showPreview"
    :url-list="previewList"
    :initial-index="previewIndex"
    @close="closePreview"
    teleported
  />
            <div class="photo-actions">
          <el-button 
            type="danger" 
            size="mini" 
            circle
            @click.stop="deletePhoto(photo)"
            :icon="Delete"
          />
        </div>
          </div>
        </div>
      </div>
    </el-dialog>
  </div>
    </div>
  </template>
  
  <script setup>
  import { ref, onMounted  } from 'vue';
  import { useRouter } from 'vue-router';
  import axios from 'axios';
  import { ElMessage,ElMessageBox,ElLoading } from 'element-plus';
  import { computed } from 'vue';
  import { Search, Plus, Edit, Delete, Document, Download, Upload, View } from '@element-plus/icons-vue';
  
// 照片回忆相关状态
const uploadProgress = ref(0); // 上传进度
const loading = ref(null);     // 加载状态
const albumSearch = ref('');
const photoAlbums = ref([]);
const albumCurrentPage = ref(1);
const albumPageSize = ref(10);
const albumTotal = ref(0);
const albumPreviewVisible = ref(false);
const currentAlbum = ref(null);
const currentAlbumPhotos = ref([]);
const showImageViewer = ref(false);
const currentPhotoIndex = ref(0);
const showPreview = ref(false)
const previewIndex = ref(0)
const previewList = ref([])
const AlbumId=ref(0);

// 计算总页数
const totalPages = computed(() => {
  return Math.ceil(albumTotal.value / albumPageSize.value) || 1;
});
// 添加这些变量和方法
const inputPage = ref(''); // 改为字符串类型
const handlePageInput = () => {
  const page = parseInt(inputPage.value);
  if (!isNaN(page) && page >= 1 && page <= totalPages.value) {
    goToPage(page);
  } else {
    // 输入无效时重置为当前页
    inputPage.value = albumCurrentPage.value;
    ElMessage.warning(`请输入有效的页码 (1-${totalPages.value})`);
  }
};



const goToPage = (page) => {
  albumCurrentPage.value = page;
  inputPage.value = page.toString(); // 更新输入框显示
  fetchPhotoAlbums ();
};

// 添加新状态
const selectedPhoto = ref(null); // 当前选中的照片
const selectPhoto = (photo) => {
  selectedPhoto.value = photo;
};
const handlePreview = (index) => {
  previewIndex.value = index
  previewList.value = currentAlbumPhotos.value.map(p => p.url)
  showPreview.value = true
}

// 关闭预览
const closePreview = () => {
  showPreview.value = false
  document.body.style.overflow = ''
  document.body.style.paddingRight = ''
}

// 重置预览状态
const resetPreview = () => {
  showPreview.value = false
  previewList.value = []
}

const fetchPhotoAlbums = async () => {
  try {
    const response = await axios.get('/photoAlbum/listByName', {
      params: {
        page: albumCurrentPage.value,
        limit: albumPageSize.value,
        name: albumSearch.value
      }
    });

    photoAlbums.value = response.data.data.records || [];
    albumTotal.value = response.data.data.total || 0;

  } catch (error) {
    console.error('获取相册列表失败:', error);
    ElMessage.error('获取相册列表失败');
  }
};
const handleFolderChange = async (e) => {
  const files = Array.from(e.target.files);
  if (files.length === 0) return;
  
  // 过滤非图片文件
  const imageFiles = files.filter(file => file.type.startsWith('image/'));
  
  if (imageFiles.length === 0) {
    ElMessage.warning('文件夹中没有图片文件');
    return;
  }

  // 显示加载状态
  const loadingInstance = ElLoading.service({
    lock: true,
    text: '正在处理图片...',
    background: 'rgba(0, 0, 0, 0.7)'
  });

  try {
    // 1. 获取文件夹名
    let folderName = "未命名相册";
    if (files[0].webkitRelativePath) {
      const parts = files[0].webkitRelativePath.split('/');
      if (parts.length > 1) {
        folderName = parts[0];
      }
    }

    // 2. 压缩并上传图片
    const formData = new FormData();
    let processedCount = 0;
    
    for (const file of imageFiles) {
      // 只压缩大于1MB的图片
      const compressedFile = file.size > 1024 * 1024 
        ? await compressImage(file)
        : file;
      
      formData.append('files', compressedFile);
      processedCount++;
      
      // 更新进度
      uploadProgress.value = Math.round((processedCount / imageFiles.length) * 100);
    }
    
    formData.append('albumName', folderName);

    // 3. 上传到服务器
    const response = await axios.post('/photoAlbum/uploadFolder', formData, {
      headers: {
        'Content-Type': 'multipart/form-data'
      },
      onUploadProgress: progressEvent => {
        const totalProgress = 50 + Math.round((progressEvent.loaded / progressEvent.total) * 50);
        uploadProgress.value = totalProgress;
      }
    });

    ElMessage.success(`成功上传${imageFiles.length}张图片到【${folderName}】`);
    
    // 4. 刷新相册列表
    fetchPhotoAlbums();
    
  } catch (error) {
    console.error('上传失败:', error);
    ElMessage.error(`上传失败: ${error.message}`);
  } finally {
    loadingInstance.close();
    uploadProgress.value = 0;
    e.target.value = ''; // 重置input
  }
};

// 图片压缩方法
const compressImage = (file) => {
  return new Promise((resolve) => {
    if (file.size < 1024 * 1024) { // 小于1MB不压缩
      resolve(file);
      return;
    }
    const reader = new FileReader();
    reader.onload = (event) => {
      const img = new Image();
      img.onload = () => {
        const canvas = document.createElement('canvas');
        const ctx = canvas.getContext('2d');
        
        // 设置最大尺寸
        const MAX_WIDTH = 1920;
        const MAX_HEIGHT = 1080;
        let width = img.width;
        let height = img.height;
        
        if (width > height) {
          if (width > MAX_WIDTH) {
            height *= MAX_WIDTH / width;
            width = MAX_WIDTH;
          }
        } else {
          if (height > MAX_HEIGHT) {
            width *= MAX_HEIGHT / height;
            height = MAX_HEIGHT;
          }
        }
        
        canvas.width = width;
        canvas.height = height;
        ctx.drawImage(img, 0, 0, width, height);
        
        // 转换为Blob
        canvas.toBlob((blob) => {
          const compressedFile = new File([blob], file.name, {
            type: 'image/jpeg',
            lastModified: Date.now()
          });
          resolve(compressedFile);
        }, 'image/jpeg', 0.7); // 0.7质量
      };
      img.src = event.target.result;
    };
    reader.readAsDataURL(file);
  });
};
const deleteAlbum = async (album) => {
  try {
    await ElMessageBox.confirm(`确定删除相册 "${album.name}" 吗?`, '提示', {
      confirmButtonText: '确定',
      cancelButtonText: '取消',
      type: 'warning'
    });
    
    await axios.delete(`/photoAlbum/delete/${album.id}`);
    ElMessage.success('删除成功');
    fetchPhotoAlbums(); // 刷新相册列表
  } catch (error) {
    if (error !== 'cancel') {
      ElMessage.error('删除失败');
    }
  }
};
// 获取相册照片列表
const fetchAlbumPhotos = async (albumId) => {
  try {
    const response = await axios.get(`/photo/getPhotos/${albumId}`);
    currentAlbumPhotos.value = response.data.data || [];
  } catch (error) {
    console.error('获取照片列表失败:', error);
    ElMessage.error('获取照片列表失败');
  }
};

const handleFileChange = async (file) => {
  const compressedFile = await compressImage(file.raw);
  const formData = new FormData();
  formData.append('file', compressedFile);
  formData.append('albumId', currentAlbum.value?.id);

  axios.post('/photo/uploadFile', formData, {
    headers: {
      'Content-Type': 'multipart/form-data',
      'Authorization': `Bearer ${localStorage.getItem('token')}`
    }
    
  }).then(response => {
    handleUploadSuccess(response.data, file);
  }).catch(error => {
    ElMessage.error('上传失败: ' + (error.response?.data?.message || error.message));
  }).finally(() => {
    const albumId = currentAlbum.value?.id;
    
  });
};


// 删除照片


// 单文件上传前检查
const beforeUpload = (file) => {
  const isImage = file.type.startsWith('image/');
  if (!isImage) {
    ElMessage.error('只能上传图片文件');
    return false;
  }
  return true;
};

// 单文件上传成功处理
const handleUploadSuccess = (response, file) => {
  if (response.code === 200) {
    ElMessage.success('上传成功');
    // 获取当前相册ID
    const albumId = currentAlbum.value?.id;
  
    // 刷新当前相册的照片列表
    fetchAlbumPhotos(albumId);
    fetchPhotoAlbums();

  } else {
    ElMessage.error(response.message || '上传失败');
  }
};



// 删除照片
const deletePhoto = async (photo) => {
  const id=photo.photoid
  try {
    await ElMessageBox.confirm('确定删除这张照片吗？', '提示', {
      confirmButtonText: '确定',
      cancelButtonText: '取消',
      type: 'warning'
    });
    
    const response = await axios.delete(`/photo/delete/${id}`);
    if (response.data.code === 200) {
      ElMessage.success('删除成功');
      fetchAlbumPhotos(photo.albumid);
    } else {
      ElMessage.error(response.data.message || '删除失败');
    }
  } catch (error) {
    if (error !== 'cancel') {
      ElMessage.error('删除失败');
    }
  }
};
const triggerFolderSelect = () => {
  document.getElementById('folderInput').click();
};
// 获取相册列表



// 获取相册预览列表
const getAlbumPreviewList = (album) => {
  return album.photos?.map(p => p.url) || [];
};

// 上传文件夹

// 改进的获取文件夹文件方法
const getFilesFromDirectory = async (directory) => {
  return new Promise((resolve) => {
    const files = [];
    
    // 处理拖拽的文件夹
    const traverseDirectory = (entry, path = '') => {
      return new Promise((resolveEntry) => {
        if (entry.isFile) {
          entry.file(file => {
            file.fullPath = path + file.name;
            files.push(file);
            resolveEntry();
          });
        } else if (entry.isDirectory) {
          const reader = entry.createReader();
          reader.readEntries(entries => {
            const promises = entries.map(e => 
              traverseDirectory(e, path + entry.name + '/')
            );
            Promise.all(promises).then(resolveEntry);
          });
        }
      });
    };
    
    const entries = Array.from(directory.items);
    const promises = entries.map(entry => traverseDirectory(entry));
    Promise.all(promises).then(() => resolve(files));
  });
};


// 打开相册
const openAlbum = (album) => {
  currentAlbum.value = album;
  currentAlbumPhotos.value = album.photos || [];
  showImageViewer.value = false;
  albumPreviewVisible.value = true;
  fetchAlbumPhotos(album.id);

};

// 打开图片查看器
const openPhotoViewer = (index) => {
  currentPhotoIndex.value = index;
  showImageViewer.value = true;
};

// 关闭图片查看器
const closeImageViewer = () => {
  showImageViewer.value = false;
    document.body.style.overflow = ''
  document.body.style.paddingRight = ''
};



  // 添加时间格式化方法
const formatDate = (timestamp) => {
  if (!timestamp) return '';
  const date = new Date(timestamp);
  const year = date.getFullYear();
  const month = String(date.getMonth() + 1).padStart(2, '0');
  const day = String(date.getDate()).padStart(2, '0');
  const hours = String(date.getHours()).padStart(2, '0');
  const minutes = String(date.getMinutes()).padStart(2, '0');
  return `${year}-${month}-${day} ${hours}:${minutes}`;
};




  const WEATHER_API_KEY = '91d0322fa7a74b3e9cf46ec505dc3346'; // 替换为你的和风天气API Key
  const weatherLoading = ref(true);
  const weatherError = ref(false);
  const weatherApi = axios.create({
    baseURL: 'https://devapi.qweather.com/v7/weather/',
    headers: {
      'X-QW-Api-Key': WEATHER_API_KEY
    }
  });
  const currentWeather = ref({
    wuxi: { icon: '100', temp: '--', text: '--' }, // 默认值
    nanjing: { icon: '100', temp: '--', text: '--' } // 默认值
  });
  const weatherIconMap = {
    '100': '100', // 晴 (日间)
    '150': '150', // 晴 (夜间)
    '101': '101', // 多云
    '102': '102', // 少云
    '103': '103', // 晴间多云
    '104': '104', // 阴
    '300': '300', // 雨
    '301': '301', // 阵雨
    '302': '302', // 雷阵雨
    '400': '400', // 雪
    '401': '401', // 阵雪
    '402': '402', // 小雪
    '403': '403', // 中雪
    '404': '404', // 大雪
    '500': '500', // 雾
    '502': '502', // 霾
    '503': '503', // 扬沙
    '504': '504', // 浮尘
    '507': '507', // 沙尘暴
    '999': '999'  // 未知
  };
  const getWeatherIcon = (iconCode) => {
    // 检查iconCode是否存在映射中，不存在则使用默认图标
    const iconName = weatherIconMap[iconCode] || '999';
    
    // 使用多个CDN源确保可用性
    const cdnUrls = [
      `https://a.hecdn.net/img/common/icon/202106d/${iconName}.png`,
      `https://www.qweather.com/img/common/icon/202106d/${iconName}.png`,
      `https://file.qweather.com/img/common/icon/202106d/${iconName}.png`
    ];
    
    return cdnUrls[0]; // 使用第一个URL，如果失败可以添加备用逻辑
  };
  // 获取实时天气数据
  const fetchCurrentWeather = async (location, city) => {
    try {
      const response = await weatherApi.get(`now?location=${location}`);
      if (response.data.code === '200') {
        currentWeather.value[city] = {
          temp: response.data.now.temp,
          text: response.data.now.text,
          icon: response.data.now.icon,
          windDir: response.data.now.windDir,
          windScale: response.data.now.windScale,
          humidity: response.data.now.humidity
        };
      } else {
        throw new Error(response.data.message || '获取天气数据失败');
      }
    } catch (error) {
      console.error(`获取${city}实时天气失败:`, error);
      throw error;
    }
  };
  const WEATHER_CACHE_KEY = 'weather_cache';
  const CACHE_EXPIRY = 5 * 60 * 1000; // 2分钟缓存时间
  // 获取天气数据
  const fetchWeather = async () => {
    const cachedData = localStorage.getItem(WEATHER_CACHE_KEY);
    if (cachedData) {
      const { data, timestamp } = JSON.parse(cachedData);
      if (Date.now() - timestamp < CACHE_EXPIRY) {
        currentWeather.value = data;
        weatherLoading.value = false;
        return; // 使用缓存数据，不调用API
      }
    }
    weatherLoading.value = true;
    weatherError.value = false;
    try {
      // 并行获取无锡和南京的天气数据
      await Promise.all([
        fetchCurrentWeather('101190201', 'wuxi'),
        fetchCurrentWeather('101190101', 'nanjing')
      ]);
      localStorage.setItem(WEATHER_CACHE_KEY, JSON.stringify({
        data: currentWeather.value,
        timestamp: Date.now()
      }));
    } catch (error) {
  
      weatherError.value = true;
      if (cachedData) {
        const { data } = JSON.parse(cachedData);
        currentWeather.value = data;
        weatherError.value = false;
      } else {
        ElMessage.error('获取天气数据失败: ' + (error.response?.data?.message || error.message));
      }
    } finally {
      weatherLoading.value = false;
    }
  };
  let weatherTimer = null;
  // 计算认识天数
  const startDate = new Date('2025-03-29'); // 设置你们认识的开始日期
  const today = new Date();
  const daysTogether = ref(Math.floor((today - startDate) / (1000 * 60 * 60 * 24)));
  
  const username = ref(localStorage.getItem('username') || '用户');
  const logout = async () => {
    try {
      // 如果有后端退出接口，可以调用
      // await axios.post('/api/auth/logout');
      
      // 清除本地存储的token和用户信息
      localStorage.removeItem('token');
      localStorage.removeItem('username');
      
      // 跳转到登录页
      router.push({ name: 'login' });
      ElMessage.success('已退出登录');
    } catch (error) {
      console.error('退出登录失败:', error);
      ElMessage.error('退出登录失败');
    }
  };
  
  const router = useRouter();
  
  // 导航项配置
  
  
  const items = ref([]);
  const currentPage = ref(1);
  const searchContent = ref('');
  const showModal = ref(false);
  const selectedRows = ref([]); 
  const form = ref({
    id: null,
    content: '',
    status: 0,
    image: '',
  });
  
  // 导航跳转
  const navigateTo = (route) => {
    router.push(route);
  };
  

  
  onMounted(() => {
  // 检查浏览器是否支持文件夹上传
  const input = document.createElement('input');
  input.type = 'file';
  if (typeof input.webkitdirectory === 'undefined') {
    ElMessage.warning({
      message: '文件夹上传功能需要Chrome或Edge浏览器支持',
      duration: 5000
    });
  }

 fetchPhotoAlbums();
    fetchWeather();
    // 每2分钟刷新一次天气
    weatherTimer = setInterval(fetchWeather, CACHE_EXPIRY);
  });
  </script>
  
  <style scoped>
  .page-input {
  display: flex;
  align-items: center;
  gap: 8px;
  font-size: 14px;
  color: #606266;
}
.pagination-container {
  margin-top: 30px;
  display: flex;
  justify-content: center;
}
.custom-pagination {
  display: flex;
  align-items: center;
  gap: 10px;
  padding: 10px;
  background: rgba(255, 255, 255, 0.9);
  border-radius: 12px;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.08);
}

.page-input .el-input {
  width: 60px;
}

.page-input .el-input__inner {
  text-align: center;
}
.total-pages {
  margin-left: 10px;
  color: #909399;
}

/* 缩略图样式 */
.photo-thumbnail {
  width: 100%;
  height: 200px;
  object-fit: cover;
  border-radius: 4px;
  display: block;
}

.photo-thumbnail:hover {
  transform: scale(1.03);
}
  /* 相册工具栏 */
.album-toolbar {
  display: flex;
  gap: 10px;
  margin-bottom: 15px;
}

/* 照片选中状态 */
.photo-selected {
  position: relative;
  outline: 3px solid var(--el-color-primary);
}

.photo-selected::after {
  content: '✓';
  position: absolute;
  top: 5px;
  right: 5px;
  width: 20px;
  height: 20px;
  background: var(--el-color-primary);
  color: white;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 12px;
}

/* 照片操作按钮 */
.photo-actions {
  position: absolute;
  top: 5px;
  right: 5px;
  opacity: 0;
  transition: opacity 0.3s;
}

.photo-item:hover .photo-actions {
  opacity: 1;
}
/* 添加上传区域的视觉反馈 */
.photo-upload-section {
  position: relative;
  transition: all 0.3s ease;
}

.upload-btn {
  transition: transform 0.2s ease;
}

.upload-btn:active {
  transform: scale(0.98);
}
.upload-progress {
  margin-top: 20px;
  width: 100%;
  max-width: 500px;
}

.progress-text {
  text-align: center;
  margin-top: 8px;
  font-size: 14px;
  color: #666;
}
  /* 拖拽区域样式 */
  :deep(.el-upload.dragover) {
  border-color: #409eff;
  background-color: rgba(64, 158, 255, 0.1);
}

/* 拖拽区域增强样式 */
:deep(.el-upload-dragger) {
  width: 100%;
  min-height: 200px;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 40px;
  border: 2px dashed #dcdfe6;
  border-radius: 8px;
  background-color: #fafafa;
  transition: all 0.3s;
  cursor: pointer;
}

:deep(.el-upload-dragger:hover) {
  border-color: #409eff;
}

.upload-area {
  text-align: center;
}

.upload-text {
  margin-top: 15px;
}

.upload-text .tip {
  font-size: 12px;
  color: #909399;
  margin-top: 8px;
}
.photo-memory {
  margin: 20px 0;
  padding: 20px;
  background-color: #fff;
  border-radius: 12px;
  box-shadow: 0 2px 12px rgba(0, 0, 0, 0.08);
}

.photo-upload-section {
  display: flex;
  align-items: center;
  margin-bottom: 20px;
  padding-bottom: 20px;
  border-bottom: 1px solid #ebeef5;
}

.upload-photo-button {
  background: linear-gradient(135deg, #ff758c 0%, #ff7eb3 100%);
  border: none;
  border-radius: 8px;
  padding: 12px 24px;
  font-weight: 500;
  transition: all 0.3s;
}

.upload-photo-button:hover {
  transform: translateY(-2px);
  box-shadow: 0 4px 12px rgba(255, 117, 140, 0.3);
}

.photo-albums-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 20px;
}

.photo-albums-header h3 {
  margin: 0;
  font-size: 18px;
  color: #303133;
}

/* 相册卡片样式 */
.album-container {
  margin: 0 -10px;
}

.album-card {
  position: relative;
  margin: 10px;
  border-radius: 12px;
  overflow: hidden;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);
  transition: all 0.3s ease;
  cursor: pointer;
  background: #ffffff;
}

.album-card:hover {
  transform: translateY(-5px);
  box-shadow: 0 8px 24px rgba(0, 0, 0, 0.15);
}

.album-cover {
  position: relative;
  width: 100%;
  height: 180px;
  overflow: hidden;
}

.album-cover-image {
  width: 100%;
  height: 100%;
  transition: transform 0.5s ease;
}

.album-card:hover .album-cover-image {
  transform: scale(1.05);
}

.album-cover-error {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  width: 100%;
  height: 100%;
  background: #f5f5f5;
  color: #999;
}

.album-cover-error .el-icon {
  font-size: 40px;
  margin-bottom: 10px;
}

.album-info {
  position: absolute;
  bottom: 0;
  left: 0;
  right: 0;
  padding: 15px;
  background: linear-gradient(transparent, rgba(0, 0, 0, 0.7));
  color: #fcd2d9;
}

.album-name {
  font-size: 16px;
  font-weight: 600;
  margin-bottom: 5px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.album-count {
  font-size: 12px;
  opacity: 0.8;
}

.album-date {
  padding: 10px;
  font-size: 12px;
  color: #999;
}

.album-actions {
  position: absolute;
  top: 10px;
  right: 10px;
}

/* 相册预览对话框 */
.album-preview-dialog :deep(.el-dialog__header) {
  background: linear-gradient(135deg, #a6c1ee 0%, #fbc2eb 100%);
  margin: 0;
  padding: 16px 20px;
  border-top-left-radius: 12px;
  border-top-right-radius: 12px;
}

.album-preview-dialog :deep(.el-dialog__title) {
  color: #fff;
  font-size: 18px;
  font-weight: 600;
}

.album-preview-container {
  height: 70vh;
  overflow: auto;
}

.album-photo-grid {
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(200px, 1fr));
  gap: 15px;
  padding: 10px;
}

.photo-item {
  position: relative;
  height: 200px;
  border-radius: 8px;
  overflow: hidden;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
  transition: all 0.3s ease;
}

.photo-item:hover {
  transform: translateY(-3px);
  box-shadow: 0 6px 16px rgba(0, 0, 0, 0.15);
}

.photo-thumbnail {
  width: 100%;
  height: 100%;
  object-fit: cover;
}

.photo-error {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
  height: 100%;
  background: #f5f5f5;
  color: #999;
}

.photo-error .el-icon {
  font-size: 40px;
}

/* 分页样式 */
.photo-pagination {
  margin-top: 20px;
  display: flex;
  justify-content: center;
}
/* 图片区域样式 */
.table-image-container {
  height: 120px;  /* 增加高度 */
  display: flex;
  align-items: center;
  justify-content: center;
}
.pdf-name {
  display: flex;
  align-items: center;
  gap: 10px;
}
  
  /* 按钮样式保持不变 */
  .header-bar {
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 0 20px;
    height: 60px;
    background-color: #fff;
    box-shadow: 0 2px 10px rgba(0, 0, 0, 0.1);
    margin-bottom: 40px;
  }
  
  .header-title {
    display: flex;
    justify-content: space-between;
    align-items: center;
    width: 100%;
  }
  
  
  .center-title {
    font-size: 20px;
    font-weight: bold;
    color: pink;
  }
  
  .days-counter {
    font-size: 14px;
    color: #666;
  }
  
  .header-actions {
    display: flex;
    align-items: center;
  }
  
  .el-dropdown-link {
    display: flex;
    align-items: center;
    cursor: pointer;
  }
  
  .username {
    margin-left: 10px;
    font-size: 16px;
  }
  
  .home-container {
    padding: 20px;
    display: flex;
    flex-direction: column;
    min-height: 100vh;
  }
  /* 导航按钮组微调 */
  .nav-buttons {
    margin-bottom: 30px;
    display: flex;
    justify-content: space-between;
    align-items: center;
    flex-wrap: wrap;
    gap: 15px;
  }
  
  
  
  
  .home-button {
    background: linear-gradient(135deg, #a6c1ee 0%, #fbc2eb 100%) !important;
  }
  .home-button:hover {
    transform: translateY(-2px);
    box-shadow: 0 6px 12px rgba(255, 154, 158, 0.4);
  }
  .el-button-group {
    display: flex;
    gap: 15px;
  }
  
  /* 导航按钮样式 */
  .nav-button {
    font-weight: bold;
    padding: 12px 22px;
    border-radius: 8px;
    font-size: 16px;
    transition: all 0.3s ease;
    position: relative;
    overflow: hidden;
    border: none;
    color: #fff;
  }
  .nav-button:nth-child(1) {
    background: linear-gradient(135deg, #a18cd1 0%, #fbc2eb 100%);
    box-shadow: 0 4px 6px rgba(161, 140, 209, 0.3);
  }
  
  .nav-button:nth-child(2) {
    background: linear-gradient(135deg, #fbc2eb 0%, #a6c1ee 100%);
    box-shadow: 0 4px 6px rgba(251, 194, 235, 0.3);
  }
  
  .nav-button:nth-child(3) {
    background: linear-gradient(135deg, #84fab0 0%, #8fd3f4 100%);
    box-shadow: 0 4px 6px rgba(132, 250, 176, 0.3);
  }
  
  .nav-button:nth-child(4) {
    background: linear-gradient(135deg, #ffc3a0 0%, #ffafbd 100%);
    box-shadow: 0 4px 6px rgba(255, 195, 160, 0.3);}
  
  .nav-button:nth-child(5) {
    background: linear-gradient(135deg, #ffb347 0%, #ffcc33 100%);
    box-shadow: 0 4px 6px rgba(255, 179, 71, 0.3);
  }
  
  .nav-button:nth-child(6) {
    background: linear-gradient(135deg, #4776e6 0%, #8e54e9 100%);
    box-shadow: 0 4px 6px rgba(71, 118, 230, 0.3);
  }
  .nav-button:hover {
    transform: translateY(-2px);
    box-shadow: 0 6px 12px rgba(0, 0, 0, 0.15);
  }
  .password-button {
    background: linear-gradient(135deg, #667eea 0%, #764ba2 100%) !important;
  }
  .password-button:hover {
    transform: translateY(-2px);
    box-shadow: 0 6px 12px rgba(102, 126, 234, 0.4);
  }
  
  /* 按钮悬停效果增强 */
  .home-button:hover,
  .nav-button:hover,
  .password-button:hover {
    filter: brightness(1.05);
  }
  /* 按钮激活效果 */
  .home-button:active,
  .nav-button:active,
  .password-button:active {
    transform: translateY(1px);
    box-shadow: 0 2px 4px rgba(0, 0, 0, 0.2);
  }
  
  
  .main-content {
    flex: 1;
    display: flex;
    flex-direction: column;
  }
  
  
  .search-box {
    width: 60%;
    min-width: 500px;
    max-width: 700px;
  }
  .search-box-container {
    display: flex;
    justify-content: center;
    margin-bottom: 25px;
    width: 100%;
  }
  .search-input {
    border-radius: 20px;
    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
  }
  .search-input :deep(.el-input__inner) {
    height: 40px;
    border-radius: 20px 0 0 20px;
    padding-left: 20px;
    font-size: 16px;
  }
  .search-button {
    height: 40px;
    border-radius: 0 20px 20px 0;
    background: linear-gradient(135deg, #a6c1ee 0%, #fbc2eb 100%);
    color: white;
    border: none;
  }
  
  

  
  .action-buttons {
    margin-bottom: 20px;
  }
  
  .pagination {
    margin-top: 20px;
    display: flex;
    justify-content: center;
  }
  

  
 
  .weather-info {
    display: flex;
    align-items: center;
    font-size: 17px; /* 增大字体 */
    font-family: 'PingFang SC', 'Microsoft YaHei', sans-serif; /* 更优雅的字体 */
    color: #5a5a5a; /* 更柔和的文字颜色 */
    text-shadow: 0 1px 2px rgba(0, 0, 0, 0.1); /* 微妙的文字阴影 */
  }
  
  
  .weather-item {
    display: inline-flex;
    align-items: center;
    margin: 0 10px;
    padding: 6px 12px;
    border-radius: 8px;
    background: rgba(255, 255, 255, 0.8);
    box-shadow: 0 2px 8px rgba(22, 13, 128, 0.08);
    transition: all 0.3s ease;
  }
  
  .weather-item:hover {
    background: rgba(255, 255, 255, 0.95);
    box-shadow: 0 4px 12px rgba(0, 0, 0, 0.12);
  }
  .weather-icon {
    width: 30px;
    height: 30px;
    margin-right: 10px;
    filter: drop-shadow(0 2px 4px rgba(0, 0, 0, 0.15));
  }
  
  
  .days-counter {
    font-size: 17px;
    font-weight: 600;
    font-family: 'PingFang SC', 'Microsoft YaHei', sans-serif;
    color: #ff6b9e; /* 更柔和的粉色 */
    margin-left: -30px; /* 再向左移动 */
    padding: 6px 14px;
    border-radius: 15px;
    background: linear-gradient(135deg, rgba(255, 182, 193, 0.2) 0%, rgba(255, 215, 0, 0.1) 100%);
    box-shadow: 0 3px 10px rgba(255, 107, 158, 0.2);
    text-shadow: 0 1px 2px rgba(0, 0, 0, 0.1);
    transition: all 0.3s ease;
    margin-right: 100px;
  
  }
  .days-counter:hover {
    transform: scale(1.02);
    box-shadow: 0 4px 14px rgba(255, 107, 158, 0.3);
  }
  .action-buttons {
    margin-bottom: 25px;
    display: flex;
    gap: 15px;
  }
  .action-buttons .el-button {
    font-weight: 600;
    font-size: 15px;
    padding: 12px 25px;
    border-radius: 8px;
    border: none;
    color: white;
    box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);
    transition: all 0.3s ease;
  }
  
  @keyframes rotating {
    0% {
      transform: rotate(0deg);
    }
    100% {
      transform: rotate(360deg);
    }
  }
  </style>